module.exports = __webpack_public_path__ + "static/media/Enterprise.40adb2bf.svg";